import {createContext, useContext} from 'react';

// Контекст отдельным файлом от провайдера — иначе react-refresh теряет
// быстрый ререндер: в одном модуле не должно быть и компонента, и не-компонента.
export const ThemeContext = createContext(null);

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within a ThemeProvider');
  return ctx;
};
